export { default as Call24x24Icon } from './ic_call_24x24.svg';
export { default as Folder32x32Icon } from './ic_folder_32x32.svg';
export { default as Globe24x24Icon } from './ic_globe_24x24.svg';
export { default as ImageAdd24x24Icon } from './ic_image_add_24x24.svg';
export { default as Mail40x40Icon } from './ic_mail_40x40.svg';
export { default as Send24x24Icon } from './ic_send_24x24.svg';
export { default as Thunder20x20Icon } from './ic_thunder_20x20.svg';
export { default as Timer24x24Icon } from './ic_timer_24x24.svg';
export { default as Quotation32x32Icon } from './ic_utility_bill.svg';
export { default as Quotation16x16Icon } from './ic_utility_bill_16x16.svg';
